<template>
    <b-form-select
            v-model="modelForm[modelName]"
            :options="options"
            :value-field="valueField"
            :text-field="textField"
            class="border-gray-300 focus:ring-0 h-11"
    />
</template>

<script>
    export default {
        name: "SelectTag",
        props: {
            modelName: {
                type: String,
                // todo turn on when phpStorm starts understanding child change
                // required: true,
            },
            modelForm: {
                type: Object,
                // required: true,
            },
            options: {
                type: Array,
                // required: true,
            },

            // optional
            valueField: {
                type: String,
                default: "id",
            },
            textField: {
                type: String,
                default: "name",
            },
        },
    }
</script>
